<style lang="stylus" scoped>
    .recommend-searchbox
        position relative
        width 100%
        height 40px
        display flex
        align-items center
        column-gap 4px
        padding 6px
        border-radius 8px
        border 1px solid #FFFFFF
        box-shadow 0px 2px 15px 0px #004C990D
        background #FFFFFFB2
        &:hover
            border-color var(--themeColor)
        &:focus-within
            border-color var(--themeColor)
            .search-history
                display block
        >img
            width 24px
            height 24px
            margin-left 2px
            flex-shrink 0
            cursor pointer
        input
            width 100%
            font-size 12px
            line-height 16px
            height 16px
            color #222
            outline none
            border none
            background none
            &::placeholder
                color #22222266
        .btn
            display flex
            justify-content center
            align-items center
            height 28px
            min-width 72px
            padding 0 24px
            border-radius 6px
            background var(--themeColor)
            color #fff
            font-size 12px
            cursor pointer
            user-select none
            &:hover
                background var(--themeHover)

        .search-history
            display none
            position absolute
            top 43px
            left 0
            width 100%
            border-radius 8px
            padding 24px
            background #fff
            box-shadow 0px 15px 30px 0px #00000026
            .switchbar
                position relative
                width 100%
                height 30px
                background #F2F4F9
                border-radius 6px
                padding 3px
                display flex
                column-gap 2px
                margin-bottom 24px
                .switchitem
                    display flex
                    justify-content center
                    align-items center
                    width 50%
                    border-radius 4px
                    font-size 12px
                    color #0000008F
                    cursor pointer
                    user-select none
                    transition background .1s linear
                    z-index 1
                    &.active
                        color #000
                    &:not(.active):hover
                        color #000
                .switchbg
                    position absolute
                    left 3px
                    width calc(50% - 3px)
                    height 24px
                    border-radius 4px
                    background #fff
                    box-shadow 0px 2px 4px 0px #00000005, 0px 1px 6px -1px #00000005,0px 1px 2px 0px #00000008
                    transition left .2s linear
                    &.move
                        left 50%
            .recommend-searchline
                &:not(:first-child)
                    margin-top 24px
                .searchline-topbar
                    display flex
                    justify-content space-between
                    height 16px
                    margin-bottom 16px
                    .searchline-title
                        font-size 12px
                        color #22222266

                    .searchline-icon
                        width 24px
                        height 24px
                        padding 4px
                        cursor pointer
                        border-radius 4px
                        &:hover
                            background rgba(0,0,0,0.06)
                        svg
                            width 16px
                            height 16px
                            color #222

                    .searchline-textbtn
                        color var(--themeColor)
                        font-size 12px
                        line-height 16px
                        cursor pointer
                        user-select none
                .search-list
                    display flex
                    column-gap 8px
                    .searchhistory-item
                        display flex
                        justify-content center
                        align-items center
                        max-width 134px
                        height 32px
                        padding 8px 16px
                        border-radius 4px
                        background #F2F4F9
                        cursor pointer
                        user-select none
                        p
                            font-size 12px
                            color #000
                            textOverflow()
                        &:hover
                            p
                                color var(--themeColor)
                    .searchhot-item
                        display flex
                        justify-content center
                        align-items center
                        max-width 134px
                        height 32px
                        padding 8px 12px
                        border-radius 4px
                        background #F2F4F9
                        cursor pointer
                        user-select none
                        &:hover
                            p
                                color var(--themeColor)
                        .searchhot-num
                            flex-shrink 0
                            width 16px
                            height 16px
                            margin-right 8px
                            border-radius 4px
                            font-size 10px
                            color #fff
                            text-align center
                            line-height 16px
                            background linear-gradient(358.48deg, #BFBFBF 7.06%, #DDDDDD 98.56%)
                            &.red
                                background linear-gradient(358.48deg, #FF1212 7.06%, #FF9089 98.56%)
                            &.orange
                                background linear-gradient(358.48deg, #FF7612 7.06%, #FFB076 98.56%)
                            &.yellow
                                background linear-gradient(358.48deg, #FFB801 7.06%, #FFD874 98.56%)
                        p
                            textOverflow()
                            font-size 12px
                            color #000

                .album-list
                    display flex
                    column-gap 16px
                    .album-item
                        position relative
                        height 80px
                        flex-grow 1
                        cursor pointer
                        img
                            width 100%
                            height 100%
                            border-radius 8px
                    .album-item-en
                        position relative
                        height 80px
                        flex-grow 1
                        cursor pointer
                        border-radius 8px
                        img
                            position absolute
                            width 60px
                            height 60px
                            top 50%
                            right 10px
                            transform translateY(-50%)
                        p
                            position absolute
                            top 50%
                            left 16px
                            color #000
                            font-size 14px
                            font-weight 700
                            max-width 50%
                            transform translateY(-50%)
                            pointer-events none
                        &.album-item-red
                            background #ffdce5
                        &.album-item-green
                            background #ccf3ee
                        &.album-item-blue
                            background #dcecfe
                .recent-list
                    margin-top -4px
                    .recent-item
                        display flex
                        align-items center
                        height 56px
                        margin-left - 10px
                        padding-left 10px
                        border-radius 6px
                        cursor pointer
                        user-select none
                        &:hover
                            background rgba(242,244,249,0.6)
                        >img
                            flex-shrink 0
                            width 32px
                            height 32px
                            margin-right 8px
                        .recent-item-right
                            .recent-item-title
                                width 100%
                                font-size 12px
                                color #222
                            .recent-item-path
                                display flex
                                svg
                                    flex-shrink 0
                                    width 16px
                                    height 16px
                                    color #22222266
                                    margin-right 4px
                                p
                                    color #22222266
                            .recent-item-time
                                font-size 12px
                                color #22222266

                    .recent-empty
                        display flex
                        flex-direction column
                        justify-content center
                        align-items center
                        padding-bottom 24px
                        img
                            width 140px
                            margin-top 16px
                            margin-bottom 8px
                        p
                            font-size 12px
                            line-height 16px
                            color #22222266
                .recent-loading
                    display flex
                    justify-content center
                    align-items center
                    width 100%
                    padding 16px 0
                    svg
                        width 40px
                        height 40px
</style>

<template>
    <div class="recommend-searchbox">
        <img src="@/home/assets/img/newPage/recommend-new/search.svg" alt="" />
        <input
            type="text"
            ref="inputEl"
            v-model="recommendSearchStr"
            maxlength="50"
            @focus="init()"
            @keyup.enter="toSearch()"
            @input="debounceSearch"
            :placeholder="$t('inputSearch')"
        />
        <div class="btn" @mousedown.prevent="searchFromBtn">{{ $t("search") }}</div>

        <div class="search-history" @mousedown.prevent>
            <div class="switchbar">
                <div class="switchbg" :class="{ move: menuIndex == 1 }"></div>
                <div class="switchitem" :class="{ active: menuIndex == 0 }" @click="toMenu(0)">{{ $t("template") }}</div>
                <div class="switchitem" :class="{ active: menuIndex == 1 }" @click="toMenu(1)">{{ $t("file") }}</div>
            </div>

            <div class="recommend-searchline" v-if="historyList.length > 0 && (menuIndex == 0 || (!showSearchResult && !showSearchLoading))">
                <div class="searchline-topbar">
                    <p class="searchline-title">{{ $t("historySearch") }}</p>
                    <div class="searchline-icon" @mousedown.prevent="cleanHistory">
                        <iconSymbol name="recommend-clean" />
                    </div>
                </div>

                <div class="search-list">
                    <div class="searchhistory-item" v-for="item in historyList" :key="item" :title="item" @mousedown="searchFromHistory(item)">
                        <p>{{ item }}</p>
                    </div>
                </div>
            </div>

            <div class="recommend-searchline" v-show="menuIndex == 0">
                <div class="searchline-topbar">
                    <p class="searchline-title">{{ $t("hotSearch") }}</p>
                </div>

                <div class="search-list">
                    <div class="searchhot-item" v-for="(item, index) in hotList" :key="item" :title="item" @mousedown="searchFromHot(item)">
                        <div class="searchhot-num" :class="{ red: index == 0, orange: index == 1, yellow: index == 2 }">{{ index + 1 }}</div>
                        <p>{{ item }}</p>
                    </div>
                </div>
            </div>

            <div class="recommend-searchline" v-show="menuIndex == 0">
                <div class="searchline-topbar">
                    <p class="searchline-title">{{ $t("featuredAlbumn") }}</p>
                    <a
                        v-if="internal"
                        class="searchline-textbtn"
                        href="https://www.edrawmax.cn/templates/album/all"
                        target="_blank"
                        @click="clickMoreAlbumn"
                    >
                        {{ $t("more") }}
                    </a>
                    <div v-else class="searchline-textbtn" @click="toAllAblumn">
                        {{ $t("more") }}
                    </div>
                </div>
                <div class="album-list" v-if="internal">
                    <a class="album-item" v-for="item in albumList" :key="item.id" :href="item.link" target="_blank" @click="clickAlbumn(item.link)">
                        <img :src="item.cover_url" alt="" />
                    </a>
                </div>
                <div class="album-list" v-else>
                    <div
                        class="album-item-en"
                        :class="['album-item-red', 'album-item-green', 'album-item-blue'][index]"
                        v-for="(item, index) in albumList"
                        :key="item.id"
                        @click="setCollectionId(item.tag_id)"
                    >
                        <img :src="item.banner_photo" alt="" />
                        <p>{{ item.show_title }}</p>
                    </div>
                </div>
            </div>

            <div class="recommend-searchline" v-show="menuIndex == 1">
                <div class="searchline-topbar">
                    <p class="searchline-title">{{ $t(fileText) }}</p>
                </div>

                <div class="recent-list" v-if="!showSearchLoading && !showSearchResult">
                    <div class="recent-item" v-for="item in displayRecentList" :key="item.id" @click="openRecent(item)">
                        <img src="@/home/assets/img/newPage/recommend-new/file.svg" alt="" />
                        <div class="recent-item-right">
                            <p class="recent-item-title">{{ item.name }}</p>
                            <div class="recent-item-path">
                                <iconSymbol name="recommend-cloud" />
                                <p>{{ item.path }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="recent-loading" v-else-if="showSearchLoading">
                    <svg
                        version="1.1"
                        id="loader-1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="50px"
                        height="50px"
                        viewBox="0 0 50 50"
                        style="enable-background: new 0 0 50 50"
                        xml:space="preserve"
                    >
                        <path
                            fill="#017fff"
                            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                        >
                            <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="rotate"
                                from="0 25 25"
                                to="360 25 25"
                                dur="0.8s"
                                repeatCount="indefinite"
                            />
                        </path>
                    </svg>
                </div>

                <div class="recent-list" v-else>
                    <div class="recent-item" v-for="item in list" :key="item.id" @click="openSearchResult(item)">
                        <img src="@/home/assets/img/newPage/recommend-new/file.svg" alt="" />
                        <div class="recent-item-right">
                            <p class="recent-item-title">{{ item.name }}</p>
                            <div class="recent-item-time">
                                <p>{{ formatDate(item.lastModified) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="recent-empty" v-if="list.length == 0">
                        <img src="@/home/assets/img/newPage/recommend-new/search-empty.svg" alt="" />
                        <p>{{ $t("emptyText") }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
    import debounce from "lodash.debounce";
    import { safeEncodeURIComponent } from "@/public/utils/tool.js";
    import fileItem from "@/home/parts/fileItem";

    @Component
    export default class RecommendSearch extends Mixins(fileItem) {
        menuIndex = 0;
        toMenu(index) {
            this.showSearchResult = false;
            this.menuIndex = index;
            if (this.menuIndex == 1 && this.recommendSearchStr != "") {
                // 切换至文件tab时主动触发一次搜索
                this.searchData();
            }

            this.sensors.track("searchPadClick", {
                Catalogues: "searchMainpage",
                click_type: "tab",
                click_tab: index == 0 ? "template" : "file",
                click_value: index == 0 ? "templateTab" : "fileTab",
            });
        }
        historyList = [];
        hotList = [];
        get userInfo() {
            return this.$store.state.userInfo || (this.$store.state.user && this.$store.state.user.userInfo) || {};
        }

        init() {
            this.initHistory();
            this.initHotList();
            this.initAlbumList();
            this.initRecent();
        }
        initHistory() {
            const storageHistory = localStorage.getItem(`homeSearchHistory_${this.userInfo.user_id}`);
            this.historyList = storageHistory ? JSON.parse(storageHistory) : [];
        }
        initHotList() {
            this.$edApi.getSearchHotkey({ lang: this.internal ? "zh" : this.lang, count: 5 }).then((res) => {
                if (res instanceof Array) {
                    this.hotList = res.map((item) => item.name);
                }
            });
        }
        albumList = [];
        initAlbumList() {
            if (this.internal) {
                this.$edApi.getAlbumList({ lang: this.internal ? "zh" : this.lang, count: 3 }).then((res) => {
                    if (res instanceof Array) {
                        this.albumList = res.map((item) => {
                            item.cover_url = `${window["GLOBAL"].PUBLIC_OSS_HOST}${safeEncodeURIComponent(item.cover_url)}main.svg`;
                            item.link = `https://www.edrawmax.cn/templates/album/${item.id}`;
                            return item;
                        });
                    }
                });
            } else {
                this.$store.dispatch("getSpecialTags", this.lang).then((e) => {
                    this.albumList = e.slice(0, 3);
                });
            }
        }

        get fileText() {
            if (this.showSearchResult || this.showSearchLoading) {
                return "searchResult";
            } else {
                return "recentFile";
            }
        }
        get displayRecentList() {
            return this.recentList.slice(0, 4);
        }
        recentList = [];
        initRecent() {
            let obj = {
                platform: this.$store.state.publicStore.runPlatform,
            };
            Object.assign(obj, this.params);
            this.$edApi
                .getOpenRecord(obj)
                .then((list) => {
                    list.sort((a, b) => {
                        return new Date(b.opened_at).getTime() - new Date(a.opened_at).getTime();
                    });
                    let arr = [];
                    let index = 0;
                    const calcPath = (str) => {
                        let list = str.split("/");
                        list.shift();
                        list.pop();
                        return list.join("/");
                    };
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].obj) {
                            let obj = {
                                index: index,
                                id: list[i].id,
                                objId: list[i].obj_id,
                                key: list[i].obj.obj,
                                size: list[i].obj.size,
                                opened_at: list[i].opened_at,
                                info: list[i].obj || null,
                                name: "",
                                path: calcPath(list[i].obj.obj),
                            };
                            let nameList = obj.key.split("/");
                            let name = nameList[nameList.length - 1];
                            name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                            obj.name = name;
                            arr.push(obj);
                            index++;
                        }
                    }
                    this.recentList = arr;
                })
                .catch((err) => {});
        }

        recommendSearchStr = "";
        toSearch() {
            if (this.showSearchResult && this.list.length == 0 && this.menuIndex == 1) {
                // 文件下搜索结束后无结果不响应回车
                return;
            }
            if (this.recommendSearchStr.trim() == "") {
                return;
            }
            this.addToHistory(this.recommendSearchStr);
            this.$router.push({
                path: `/${this.lang}/search-result`,
                query: {
                    search: this.recommendSearchStr,
                    type: this.menuIndex == 0 ? "template" : "file",
                },
            });
        }
        searchFromBtn() {
            let str = this.recommendSearchStr.trim();
            if (!str) {
                (this.$refs.inputEl as HTMLInputElement).focus();
                return;
            }
            this.toSearch();
        }

        searchFromHistory(str) {
            this.recommendSearchStr = str.trim();
            if (this.menuIndex == 0) {
                this.toSearch();
            } else {
                this.searchData();
            }

            this.sensors.track("searchPadClick", {
                Catalogues: "searchMainpage",
                click_type: "history",
                click_tab: this.menuIndex == 0 ? "template" : "file",
                click_value: this.recommendSearchStr,
            });
        }
        addToHistory(str) {
            const storageKey = `homeSearchHistory_${this.userInfo.user_id}`;
            const storageHistory = localStorage.getItem(storageKey);
            let list = storageHistory ? JSON.parse(storageHistory) : [];
            let index = list.findIndex((item) => str == item);
            if (index !== -1) {
                list.splice(index, 1);
            }
            list.unshift(str);
            list.length > 5 && (list.length = 5);
            this.historyList = list;
            localStorage.setItem(storageKey, JSON.stringify(list));
        }
        cleanHistory() {
            const storageKey = `homeSearchHistory_${this.userInfo.user_id}`;
            this.historyList = [];
            localStorage.setItem(storageKey, "");
        }

        searchFromHot(item) {
            this.recommendSearchStr = item;
            this.toSearch();

            this.sensors.track("searchPadClick", {
                Catalogues: "searchMainpage",
                click_type: "hot",
                click_tab: "template",
                click_value: this.recommendSearchStr,
            });
        }

        // 实时搜索
        showSearchResult = false;
        list = [];
        searchTaskId = 0;
        showSearchLoading = false;
        searchData() {
            this.showSearchResult = false;
            this.showSearchLoading = true;
            ++this.searchTaskId;
            if (this.menuIndex == 0 || this.recommendSearchStr.trim() == "") {
                this.showSearchLoading = false;
                return;
            }
            let id = this.searchTaskId;
            this.list = [];
            this.$store
                .dispatch("searchFile", { value: this.recommendSearchStr })
                .then((res) => {
                    res.data.data.map((item) => {
                        let filePath: any = [];
                        filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                        filePath = filePath.split("/");
                        let name = filePath.pop();
                        filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                        name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                        item.name = name;
                    });
                    if (id == this.searchTaskId) {
                        this.list = res.data.data.slice(0, 4);
                        this.sensors.track("searchResult", {
                            Catalogues: "searchMainpage",
                            search_space: "realtime",
                            search_value: this.list.length > 0 ? "cloud_file" : "none",
                        });
                        this.showSearchResult = true;
                        this.showSearchLoading = false;
                    }
                })
                .catch((err) => {
                    this.list = [];
                });
        }
        debounceSearch = debounce(this.searchData, 200);

        openRecent(item) {
            this.openFiles(item);
            this.sensors.track("searchPadClick", {
                Catalogues: "searchMainpage",
                click_type: "recent",
                click_tab: "file",
                click_value: item.name,
            });
        }

        openSearchResult(item) {
            this.openFiles(item);
        }

        toAllAblumn() {
            // 前往全部专辑页
            this.$bus.$emit("changeOnlineSlide", 3);
            this.$store.commit("setState", {
                type: "templateSelect",
                data: "tags",
            });
            this.clickMoreAlbumn();
        }

        clickMoreAlbumn() {
            this.sensors.track("searchPadClick", {
                Catalogues: "searchMainpage",
                click_type: "recommend",
                click_tab: "template",
                click_value: "viewAll",
            });
        }
        clickAlbumn(link) {
            this.sensors.track("searchPadClick", {
                Catalogues: "searchMainpage",
                click_type: "recommend",
                click_tab: "template",
                click_value: link,
            });
        }

        setCollectionId(data: number) {
            if (!this.$validateLogin()) return;
            this.$bus.$emit("changeOnlineSlide", 3);
            this.$store.commit("setState", {
                type: "templateSelect",
                data: "tagInfo",
            });
            this.$store.commit("setState", {
                type: "tagId",
                data,
            });
            this.$store.commit("setState", {
                type: "fromAllTags",
                data: false,
            });
            this.sensors.track("searchPadClick", {
                Catalogues: "searchMainpage",
                click_type: "recommend",
                click_tab: "template",
                click_value: "tagid:" + data,
            });
        }

        created() {}
        mounted() {
            // this.init();
        }
    }
</script>
<i18n>
{
    "zh": {
        "search": "搜索",
        "inputSearch": "搜索绘图类型、模板、文件等...",
        "template": "模板",
        "file": "文件",
        "historySearch": "历史搜索",
        "hotSearch": "热门搜索",
        "featuredAlbumn": "精选专辑",
        "more": "查看更多",
        "recentFile": "最近文件",
        "searchResult": "搜索结果",
        "emptyText": "无匹配文件"
    },
    "en": {
        "search": "Search",
        "inputSearch": "Search drawing types, templates, files, etc.",
        "template": "Template",
        "file": "File",
        "historySearch": "Search History",
        "hotSearch": "Popular Searches",
        "featuredAlbumn": "Collections",
        "more": "View All",
        "recentFile": "Recent Files",
        "searchResult": "Search results",
        "emptyText": "No matching files found"
    },
    "fr": {
        "search": "Chercher",
        "inputSearch": "Rechercher des types de dessin, modèles, fichiers, etc.",
        "template": "Modèles",
        "file": "Fichier",
        "historySearch": "Historique de recherche",
        "hotSearch": "Recherches populaires",
        "featuredAlbumn": "Collections",
        "more": "Afficher tout",
        "recentFile": "Fichiers récents",
        "searchResult": "Résultats de la recherche",
        "emptyText": "Aucun fichier correspondant trouvé"
    },
    "de": {
        "search": "Suchen",
        "inputSearch": "Suchen Sie nach Zeichnungstypen, Vorlagen, Dateien usw.",
        "template": "Vorlagen",
        "file": "Datei",
        "historySearch": "Suchverlauf",
        "hotSearch": "Beliebte Suchvorgänge",
        "featuredAlbumn": "Sammlungen",
        "more": "Alle anzeigen",
        "recentFile": "Zuletzt verwendete Dateien",
        "searchResult": "Suchergebnisse",
        "emptyText": "Keine übereinstimmenden Dateien gefunden"
    },
    "jp": {
        "search": "検索",
        "inputSearch": "図面タイプ、テンプレート、ファイルなどを検索します",
        "template": "テンプレート",
        "file": "ファイル",
        "historySearch": "検索履歴",
        "hotSearch": "人気の検索",
        "featuredAlbumn": "コレクション",
        "more": "すべて表示",
        "recentFile": "最近のファイル",
        "searchResult": "検索結果",
        "emptyText": "一致するファイルが見つかりません"
    },
    "es": {
        "search": "Buscar",
        "inputSearch": "Busca tipos de dibujo, plantillas, archivos, etc.",
        "template": "Plantillas",
        "file": "Archivo",
        "historySearch": "Historial de búsqueda",
        "hotSearch": "Búsquedas populares",
        "featuredAlbumn": "Colecciones",
        "more": "Ver todo",
        "recentFile": "Archivos recientes",
        "searchResult": "Resultados de búsqueda",
        "emptyText": "No se han encontrado archivos coincidentes."
    },
    "pt": {
        "search": "Pesquisar",
        "inputSearch": "Pesquisar tipos de desenho, modelos, arquivos etc.",
        "template": "Modelos",
        "file": "Ficheiro",
        "historySearch": "Histórico de pesquisa",
        "hotSearch": "Pesquisas populares",
        "featuredAlbumn": "Coleções",
        "more": "Exibir tudo",
        "recentFile": "Arquivos recentes",
        "searchResult": "Resultados da pesquisa",
        "emptyText": "Nenhum arquivo correspondente encontrado"
    },
    "it": {
        "search": "Cerca",
        "inputSearch": "Cerca tipi di disegno, modelli, file, ecc.",
        "template": "Modelli",
        "file": "File",
        "historySearch": "Cronologia di ricerca",
        "hotSearch": "Ricerche più popolari",
        "featuredAlbumn": "Raccolte",
        "more": "Visualizza tutto",
        "recentFile": "File recenti",
        "searchResult": "Risultati della ricerca",
        "emptyText": "Non è stato trovato nessun file corrispondente"
    }
}
</i18n>
